// src/widgets/DateWidget.jsx
import { useState, useEffect } from 'react';
import { Calendar } from 'lucide-react';

export default function DateWidget() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{
      height: '100%',
      boxSizing: 'border-box',
      background: 'var(--bg-card)',
      border: '1px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 6,
      padding: 16,
      textAlign: 'center',
    }}>
      <Calendar size={16} color="var(--accent-cyan)" style={{ marginBottom: 2 }} />
      <div style={{
        fontSize: 13,
        fontWeight: 600,
        color: 'var(--text-muted)',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}>
        {now.toLocaleDateString('id-ID', { month: 'long', year: 'numeric' })}
      </div>
      <div style={{
        fontSize: 40,
        fontWeight: 700,
        fontFamily: 'var(--font-mono)',
        color: 'var(--text-primary)',
        lineHeight: 1,
      }}>
        {now.getDate()}
      </div>
      <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
        {now.toLocaleDateString('id-ID', { weekday: 'long' })}
      </div>
    </div>
  );
}